import { ReactElement } from 'react'
import { CopyToClipBoard } from 'shared/components/CopyToClipBoard/CopyToClipBoard'
import { TextProps } from 'shared/components/Text/Text'

import { useUser } from '../../helpers/useUser'
import { getJobInfo } from '../../helpers/utils'
import { Job } from '../../models/jobs'

interface ClickToCopyJobInfoProps {
  record: Job
  textProps?: Partial<TextProps>
  children: ReactElement
}

export const ClickToCopyJobInfo = ({ record, textProps, children }: ClickToCopyJobInfoProps) => {
  const { user } = useUser(record?.assigned_to?.id ?? '')
  const jobInfo = getJobInfo(record, user)

  return (
    <CopyToClipBoard text={jobInfo} textProps={textProps}>
      {children}
    </CopyToClipBoard>
  )
}
